import { Labels } from '../../shared-components/global/labels';

Labels.set('ui-upload', 'upload', 'Lisa');
Labels.set('ui-upload', 'uploadFiles', 'Laadin failid üles');
Labels.set('ui-upload', 'clear', 'Tühista fail');
